/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdultRouteImport } from './routes/adult'
import { Route as DataDeletionRouteImport } from './routes/data-deletion'
import { Route as KidsRouteImport } from './routes/kids'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RadarRouteImport } from './routes/radar'
import { Route as TermsRouteImport } from './routes/terms'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdultRoute = AdultRouteImport.update({
  id: '/adult',
  path: '/adult',
  getParentRoute: () => rootRouteImport,
} as any)
const DataDeletionRoute = DataDeletionRouteImport.update({
  id: '/data-deletion',
  path: '/data-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const KidsRoute = KidsRouteImport.update({
  id: '/kids',
  path: '/kids',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const RadarRoute = RadarRouteImport.update({
  id: '/radar',
  path: '/radar',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/adult': typeof AdultRoute
  '/data-deletion': typeof DataDeletionRoute
  '/kids': typeof KidsRoute
  '/legal': typeof LegalRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/radar': typeof RadarRoute
  '/terms': typeof TermsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/adult': typeof AdultRoute
  '/data-deletion': typeof DataDeletionRoute
  '/kids': typeof KidsRoute
  '/legal': typeof LegalRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/radar': typeof RadarRoute
  '/terms': typeof TermsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/adult': typeof AdultRoute
  '/data-deletion': typeof DataDeletionRoute
  '/kids': typeof KidsRoute
  '/legal': typeof LegalRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/radar': typeof RadarRoute
  '/terms': typeof TermsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/adult'
    | '/data-deletion'
    | '/kids'
    | '/legal'
    | '/partners'
    | '/privacy'
    | '/radar'
    | '/terms'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/adult'
    | '/data-deletion'
    | '/kids'
    | '/legal'
    | '/partners'
    | '/privacy'
    | '/radar'
    | '/terms'
  id:
    | '__root__'
    | '/'
    | '/adult'
    | '/data-deletion'
    | '/kids'
    | '/legal'
    | '/partners'
    | '/privacy'
    | '/radar'
    | '/terms'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdultRoute: typeof AdultRoute
  DataDeletionRoute: typeof DataDeletionRoute
  KidsRoute: typeof KidsRoute
  LegalRoute: typeof LegalRoute
  PartnersRoute: typeof PartnersRoute
  PrivacyRoute: typeof PrivacyRoute
  RadarRoute: typeof RadarRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/adult': {
      id: '/adult'
      path: '/adult'
      fullPath: '/adult'
      preLoaderRoute: typeof AdultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-deletion': {
      id: '/data-deletion'
      path: '/data-deletion'
      fullPath: '/data-deletion'
      preLoaderRoute: typeof DataDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kids': {
      id: '/kids'
      path: '/kids'
      fullPath: '/kids'
      preLoaderRoute: typeof KidsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/radar': {
      id: '/radar'
      path: '/radar'
      fullPath: '/radar'
      preLoaderRoute: typeof RadarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdultRoute: AdultRoute,
  DataDeletionRoute: DataDeletionRoute,
  KidsRoute: KidsRoute,
  LegalRoute: LegalRoute,
  PartnersRoute: PartnersRoute,
  PrivacyRoute: PrivacyRoute,
  RadarRoute: RadarRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
